import * as analytics from 'utilities/analytics';
import * as intercom from 'utilities/intercom';

import { DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED } from '../../../constants/events';
import {
  ADD_VIDEO_TO_TEAM_CARD_KEY,
  SHARE_VIDEO_CARD_KEY,
} from '../../../../../shared/constants/workspaceOnboarding';

const ADD_VIDEO_SUPPORT_ARTICLE_LINK =
  'https://support.loom.com/hc/en-us/articles/360005046238-How-to-manage-your-videos-within-your-Loom-Library';

const SHARE_VIDEO_ARTICLE_LINK =
  'https://support.loom.com/hc/en-us/articles/360002208157-Share-your-recording';

const PRODUCT_TOUR_ID_TEAM = 115045;
const PRODUCT_TOUR_LINK_TEAM = `/team-videos?product_tour_id=${PRODUCT_TOUR_ID_TEAM}`;

const PRODUCT_TOUR_ID_PERSONAL = 123176;

const PRODUCT_TOUR_LINK_PERSONAL = `/my-videos?product_tour_id=${PRODUCT_TOUR_ID_PERSONAL}`;

const PRODUCT_SCREENSHOT_TOUR_ID = 150597;

const SHARE_VIDEO_TOUR_ID = 115050;

const launchAddVideoToTeamArticleLink = () => {
  analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
    type: 'secondary',
    card: ADD_VIDEO_TO_TEAM_CARD_KEY,
  });

  window.open(ADD_VIDEO_SUPPORT_ARTICLE_LINK);
};

const launchAddVideoToTeamIntercomTutorial = () => {
  const tourIsOnTeamLib = PRODUCT_TOUR_LINK_TEAM.includes(
    window.location.pathname
  );
  const tourIsOnPersonalLib = PRODUCT_TOUR_LINK_PERSONAL.includes(
    window.location.pathname
  );
  const tourIsOnValidPage = tourIsOnTeamLib || tourIsOnPersonalLib;

  analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
    type: 'primary',
    card: ADD_VIDEO_TO_TEAM_CARD_KEY,
  });

  if (!tourIsOnValidPage) {
    window.location.href = PRODUCT_TOUR_LINK_TEAM;
  } else {
    let tourId = null;

    if (tourIsOnPersonalLib) {
      tourId = PRODUCT_TOUR_ID_PERSONAL;
    } else if (tourIsOnTeamLib) {
      tourId = PRODUCT_TOUR_ID_TEAM;
    }

    intercom.startTour(tourId);
  }
};

const launchTakeAScreenshotIntercomTutorial = () => {
  intercom.startTour(PRODUCT_SCREENSHOT_TOUR_ID);
};

const launchAddVideoToSharedIntercomTutorial = () => {
  intercom.startTour(SHARE_VIDEO_TOUR_ID);
};

const launchShareVideoArticleLink = () => {
  window.open(SHARE_VIDEO_ARTICLE_LINK);

  analytics.track(DASHBOARDING_ONBOARDING_CARD_CTA_CLICKED, {
    type: 'secondary',
    card: SHARE_VIDEO_CARD_KEY,
  });
};

export {
  launchAddVideoToTeamIntercomTutorial,
  launchTakeAScreenshotIntercomTutorial,
  launchAddVideoToTeamArticleLink,
  launchShareVideoArticleLink,
  launchAddVideoToSharedIntercomTutorial,
};
